module.exports = __webpack_public_path__ + "./fonts/Montserrat_400Regular.ttf";